module.exports = __webpack_public_path__ + "img/payLogo.3297bf57.png";